import { useEffect, useRef } from 'react';

/**
 * Cierra una ventana con la tecla Esc: en el iPad con teclado (y en el ordenador)
 * es lo que se espera de cualquier ventana.
 */
export const useCerrarConEscape = (onClose: () => void) => {
  // La última función, sin volver a poner el oyente en cada render
  const cerrar = useRef(onClose);
  cerrar.current = onClose;

  useEffect(() => {
    const alPulsar = (e: KeyboardEvent) => {
      if (e.key === 'Escape') cerrar.current();
    };
    document.addEventListener('keydown', alPulsar);
    return () => document.removeEventListener('keydown', alPulsar);
  }, []);
};
